import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import TosBankInfoAddForm from "../Forms/TosBankInfoAddForm";
import TosBankInfoUpdateForm from "../Forms/TosBankInfoUpdateForm";
import { useHistory } from "react-router-dom";

import { Table, Empty, Popconfirm, Col, Row, Drawer,Tooltip } from "antd";
import { EditOutlined, DeleteOutlined,RightSquareOutlined } from "@ant-design/icons";

function TosInfo(props) {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
  });

  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  useEffect(() => {
    if (props.addButtonEvent > 0) {
      setAddFormVisibility(true);
    }
  }, [props.addButtonEvent]);
  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;
    RequestHandler.get(
      `/TosBankInfo?$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getUpdateFormData = (id) => {
    RequestHandler.get(`/TosBankInfo/GetById/${id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });

    setUpdateFormVisibility(true);
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };
  const goAccountsPage = (bankId) => {
    history.push(`tenant-payment-account/${bankId}`);
  };
  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/TosBankInfo?id=${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddFormSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateFormSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      key: "bankLogo",
      width: "8%",
      render: (text, row, index) => {
        {
          if (text === "KASA HESABI") {
            return <img src={row.bankLogo}></img>;
          }
          return <img src={row.bankLogo}></img>;
        }
      },
    },
    {
      title: "Bağlantı Tipi",
      align: "center",
      render: (data,row) => {
        if(row.isUseWebService) {
          return "Web Servis";
        }

        if(row.isUseEmail) {
          return "Email";
        }

        if(row.isUsePdf) {
          return "Pdf";
        }

        return "Sftp";
      }
    },
    {
      title: "Alıcı Mail Adresleri",
      dataIndex: "emailAddresses",
      render: (data, row) => {
         if(row.isUseEmail) {
           return data.length > 1 ? `${data.length} adet mail adresi mevcut.` : data;
         }
         return "-"
      }
    },
    {
      title: "Müşteri Numarası",
      dataIndex: "customerNumber",
      render: (data, row) => {
       return data;
     }
    },
    {
      title: "Kullanıcı Adı",
      dataIndex: "userName",
      render: (data, row) => {
        if(!row.isUseEmail) {
          return data;
        }
        return "-"
     }
    },
    // {
    //     title: "Gelen Dosya Yolu",
    //     dataIndex: "uploadFolder",
    //   },
    //   {
    //     title: "Giden Dosya Yolu",
    //     dataIndex: "downloadFolder",
    //   },
    //   {
    //     title: "Host",
    //     dataIndex: "host",
    //   },
    //   {
    //     title: "Port",
    //     dataIndex: "port",
    //   },
    {
        title: "Hesaplar",
        dataIndex: "operation",
        align: "center",
        render: (text, record) =>
            <Tooltip placement="topLeft" title="Hesaplara Git">
              <a style={{ color: "#3598dc", fontSize: "170%" }}>
                <RightSquareOutlined
                onClick={() => goAccountsPage(record.bankId, record.id)} />
              </a>
            </Tooltip>
      },
    {
      title: "Düzenle",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <a onClick={() => getUpdateFormData(data)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addDrawer"
        title="Tos Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <TosBankInfoAddForm onSuccess={onAddFormSuccess} />
      </Drawer>

      <Drawer
        id="updateDrawer"
        title="Tos Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <TosBankInfoUpdateForm
          data={updateFormData}
          onSuccess={onUpdateFormSuccess}
        />
      </Drawer>
    </>
  );
}

export default TosInfo;
